import TagsInput from '../TagsInput/TagsInput';
import wrapLabelAndError from '../../behaviors/wrap_label_and_error';

const TagsInputWithLabel = wrapLabelAndError(TagsInput);
export default TagsInputWithLabel;
